import {Center, Heading, HStack, Icon, Image, Link, SimpleGrid, Text, VStack} from "@chakra-ui/react";
import * as React from "react";
import {ReactNode} from "react";
import logo from '../../assets/capta-logo-blue.svg'
import {FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp} from "react-icons/fa";
import {SiTiktok} from "react-icons/si";

interface IMainLayoutProps {
  children: ReactNode
}

export function MainLayout(props: IMainLayoutProps) {
  return (
    <VStack w="100vw" h="100vh" overflow="auto">
      <HStack bg="primary.500" w="100%" pl={{base: 4, md: 100}} py={5}>
        <HStack h="80px">
          <Link href="/">
            <Image src={logo} alt="CAPTA" h="75px"/>
          </Link>
        </HStack>
      </HStack>
      <HStack flex={1} alignItems="start">
        {props.children}
      </HStack>
      <VStack bg="primary.500" w="100%">
        <Heading size="2xl" textColor="white" mt={5}>Contáctanos</Heading>
        <SimpleGrid columns={{md: 1, lg: 3}} mb={5} spacingX={12}>
          <Center>
            <Link href="https://api.whatsapp.com/send/?phone=50240323432"
                  textColor="white" fontSize="xl" fontWeight="bold">
              <Icon as={FaWhatsapp} mr={0.5}/> +502 4032 3432
            </Link>
          </Center>

          <Center mt={{base: 1, lg: 0}}>
            <Text textColor="white" fontSize={{base: "md", md: "xl"}} fontWeight="bold">
              info@centrarecursostecnicos.com.gt
            </Text>
          </Center>

          <Center mt={{base: 2, lg: 0}}>
            <Link href="https://www.facebook.com/captaempleos" target="_blank" rel="noopener noreferrer" aria-label="Facebook"
                  textColor="white" fontSize="xl" mr={3}>
              <Icon as={FaFacebook} boxSize={8}/>
            </Link>
            <Link href="https://www.linkedin.com/company/centrarecursos-t%C3%A9cnicos" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"
                  textColor="white" fontSize="xl" mr={3}>
              <Icon as={FaLinkedin} boxSize={8}/>
            </Link>
            <Link href="https://www.instagram.com/capta_empleosgt?stkn=MTlmeXo3ZHFiYTJmdg%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" aria-label="Instagram"
                  textColor="white" fontSize="xl" mr={3}>
              <Icon as={FaInstagram} boxSize={8}/>
            </Link>
            <Link href="https://www.tiktok.com/@capta_empleos?_r=1&_t=ZS-9ACS777dZl2" target="_blank" rel="noopener noreferrer" aria-label="TikTok"
                  textColor="white" fontSize="xl">
              <Icon as={SiTiktok} boxSize={8}/>
            </Link>
          </Center>
        </SimpleGrid>
      </VStack>
    </VStack>
  );
}
